import { ReadSearchApiArg, ReadSearchApiResponse } from 'lib-search-types';

import { ajaxSend } from 'api/api';

export async function findUser(query: string) {
  const response = await ajaxSend<ReadSearchApiResponse<'users'>>({
    path: '/v4/search/users',
    method: 'POST',
    data: {
      scope: 'users',
      query,
      filters: {
        strategy: 'all',
        filters: [],
      },
      pageSize: 10,
    } satisfies ReadSearchApiArg<'users'>,
  });

  return {
    data: [
      {
        hits: response.data.results.map(({ result, highlights }) => ({
          ...result,
          display_name: result.name,
          _highlights: Object.entries(highlights).reduce(
            (acc, [key, value]) => ({
              ...acc,
              [key.replace('user_detail.', '')]: value,
            }),
            {},
          ),
        })),
        hits_per_page: response.meta.page_size,
        hits_type: 'user',
        nb_hits: response.meta.total_results,
        nb_pages: response.meta.total_pages,
        page: response.meta.page,
      },
    ],
    meta: {},
  };
}

export async function findContact(
  arg: ReadSearchApiArg<'users'>,
): Promise<ReadSearchApiResponse<'users'>> {
  const response = await ajaxSend<ReadSearchApiResponse<'users'>>({
    path: `/v4/search/users`,
    method: 'POST',
    data: arg,
  });

  return response;
}

export function getAllFrom() {
  return ajaxSend({
    path: '/v1/integrations/email',
  });
}
